export const BUDGET_RANGE_ERROR = 'Minimum budget must be less than maximum budget.';
export const BUDGET_NUMERIC_ERROR = 'Budget values must be positive whole numbers.';
export const BUDGET_REQUIRED_ERROR = 'Please enter both minimum and maximum budget amounts.';

const hasForbiddenBudgetNotation = (value) => {
  const text = String(value || '').trim();
  if (!text) return false;
  return /[kKmM₱$]|php|\./i.test(text.replace(/,/g, ''));
};

export const parseBudgetAmount = (rawValue) => {
  const text = String(rawValue || '').trim();
  if (!text) return null;
  if (hasForbiddenBudgetNotation(rawValue)) return null;
  if (!/^\d+$/.test(text.replace(/,/g, ''))) return null;

  const digits = text.replace(/,/g, '');
  const amount = Number(digits);
  if (!Number.isInteger(amount) || amount <= 0) return null;
  return amount;
};

export const normalizeBudgetDigits = (rawValue) => {
  const text = String(rawValue || '');
  if (!text) return '';
  return text.replace(/\D/g, '');
};

export const normalizeBudgetInput = (rawValue) => {
  const text = String(rawValue || '');
  if (!text.trim()) return '';
  if (hasForbiddenBudgetNotation(text) || /[^\d]/.test(text)) return text.trim();
  return text;
};

export const handleBudgetKeyDown = (event) => {
  const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
  if (allowedKeys.includes(event.key)) return;

  if ((event.ctrlKey || event.metaKey) && ['a', 'c', 'v', 'x'].includes(event.key.toLowerCase())) {
    return;
  }

  if (!/^\d$/.test(event.key)) {
    event.preventDefault();
  }
};

export const formatBudgetRange = (minAmount, maxAmount) => {
  if (!Number.isInteger(minAmount) || !Number.isInteger(maxAmount)) return '';
  return `₱${minAmount.toLocaleString('en-US')} - ₱${maxAmount.toLocaleString('en-US')}`;
};

export const validateBudgetRange = (minValue, maxValue) => {
  const minText = String(minValue || '').trim();
  const maxText = String(maxValue || '').trim();

  if (!minText || !maxText) {
    return { min: parseBudgetAmount(minValue), max: parseBudgetAmount(maxValue), error: BUDGET_REQUIRED_ERROR, field: !minText ? 'budget_min' : 'budget_max' };
  }

  const minAmount = parseBudgetAmount(minValue);
  const maxAmount = parseBudgetAmount(maxValue);
  if (minAmount == null || maxAmount == null) {
    return {
      min: minAmount,
      max: maxAmount,
      error: BUDGET_NUMERIC_ERROR,
      field: minAmount == null ? 'budget_min' : 'budget_max',
    };
  }

  if (minAmount >= maxAmount) {
    return { min: minAmount, max: maxAmount, error: BUDGET_RANGE_ERROR, field: 'budget_max' };
  }

  return { min: minAmount, max: maxAmount, error: '', field: '' };
};
